import React from 'react';
import {ClickableElement} from '../../search/search-results/search-result-details/content/clickable-section-list/clickableSectionList';

export function scrollToElementFromContent(
    scrollTarget: ClickableElement,
    scrollElementReference: React.RefObject<any>,
): void {
    const hibuPdfPreviewPageScroll: HTMLDivElement | undefined = scrollElementReference.current ?? undefined;
    if (!hibuPdfPreviewPageScroll) {
        return;
    }
    const scrollTargetYCoordinateFromTop = scrollTarget.pageHeight - scrollTarget.bottomLeftY;
    const canvasYCoordinateFromTop =
        (hibuPdfPreviewPageScroll.clientHeight * scrollTargetYCoordinateFromTop) / scrollTarget.pageHeight;

    hibuPdfPreviewPageScroll?.scrollTo(0, canvasYCoordinateFromTop);
}

export function scrollToElementFromHighlight(htmlElement: Element, scrollElementReference: React.RefObject<any>): void {
    const hibuPdfPreviewPageScroll: HTMLDivElement | undefined = scrollElementReference.current ?? undefined;
    if (!hibuPdfPreviewPageScroll) {
        return;
    }
    const canvasCoordinates = hibuPdfPreviewPageScroll.getBoundingClientRect();
    const elemCoordinates = htmlElement.getBoundingClientRect();
    const elemYCoordinateFromTop = elemCoordinates.bottom + canvasCoordinates.top;

    hibuPdfPreviewPageScroll?.scrollTo(0, elemYCoordinateFromTop);
}

export function highlightElement(element: Element): void {
    element.classList.add('current-hl');
    setTimeout(() => {
        element.classList.remove('current-hl');
    }, 1000);
}
